<template>
    <div class="modal-wrap" v-if="isShowModalIntegrate">
        <!-- 新用户注册，送券+积分 -->
        <div class="modal-integrate" v-if="isShowModalIntegrate">
            <div class="inner-integrate">
                <a class="btn-close" href="javascript: void(0)" @click.prevent="handle_closeModalIntegrate"></a>
                <p class="integrate-msg">
                    输入手机号立即注册领取
                </p>
                <form class="form-send">
                    <div class="inner-send">
                        <div class="form-input">
                            <div class="input-control">
                                <input type="tel" ref="mobile" v-model="mobile" @input="handle_input($event.target, 'mobile')" pattern="/[0-9]*/" placeholder="输入手机号" maxlength="11" />
                            </div>
                        </div>
                        <div class="form-input" v-show="isShowImgcodeFormInput">
                            <div class="input-control">
                                <input type="text" ref="imgcode" v-model="imgcode" placeholder="图形验证码" maxlength="4" />
                            </div>
                            <a class="form-verifycode" href="javascript: void(0)" ref="btnVerifyCode" @click.prevent="handle_getVerifyCode($event.target)">
                                <img v-show="imgcode_src" class="form-verifyimg" :src="imgcode_src" :data-cck="cck" />
                            </a>
                        </div>
                        <div class="form-input">
                            <div class="input-control">
                                <input type="tel" ref="smscode" v-model="smscode" @input="handle_input($event.target, 'smscode')" pattern="/[0-9]*/" placeholder="手机验证码" maxlength="4" />
                            </div>
                            <a class="get-smscode" href="javascript: void(0)" @click.prevent="handle_getSmscode($event.target)">获取验证码</a>
                        </div>
                        <a class="form-submit" href="javascript: void(0)" @click.prevent="handle_getReward($event.target)">立即领取</a>
                    </div>
                </form>
            </div>
        </div>
        <transition name="fade" mode="out-in">
            <div class="panel-box" v-show="isShowAlert">
                <transition name="bounce">
                    <div class="panel panel-alert" v-show="isShowAlert">
                        <div class="panel-inner">
                            <div class="panel-content" data-max="16">
                                <h2 v-if="alert_title">{{ alert_title }}</h2>
                                <slot>{{ alert_content }}</slot>
                            </div>
                            <div class="panel-footer">
                                <a class="panel-btnTrue" :href="alert_btnTrueHref" @click.prevent="handle_fnOk">
                                    {{ alert_btnTrueText }}
                                </a>
                            </div>
                        </div>
                    </div>
                </transition>
            </div>
         </transition>
    </div>
</template>
<script>
import Vue from 'vue';

let COOKIE_MAX_AGE = 31; //cookie最大有效期， 默认为：7天
let COOKIE_HOST_DOMAIN = 'secoo.com'; //cookie设置的域名;
let PREFIX_USER_CENTER = process.env.API_USER_CENTER || ''; //用户中心API前辍
let REQUEST_METHOD = {
    POST: 'POST',
    GET : 'GET'
};
let CONF_API = {
    //检测用户是否已有登录
    checkUserLogin: {
        method: REQUEST_METHOD.POST,
        api: '/service/appapi/login/check'
    },

    //通用：发送短信验证码(第三方登录绑定手机号功能也使用此接口)
    getSmscode: {
        method: REQUEST_METHOD.POST,
        api: '/service/appapi/user/msg/send'
    },

    //快速登录
    quickLogin: {
        method: REQUEST_METHOD.POST,
        api: '/service/appapi/user/quick/login'
    },

    //获取图形验证码
    getCaptcha: {
        method: REQUEST_METHOD.GET,
        api: '/service/appapi/captcha/v1'
    }
};

let tools = {
    cookie: (function(){
        /**
         * @description set设置cookie, del删除cookie,当expires小于0时即为删除cookie
         * @param {Object} options={name:,value:,expires:,domain:,path:,secure:,encode:}【必选】
         * @param {String} name cookie的名称【必选】
         * @param {String} value cookie的值【必选】
         * @param {Number} expires cookie的过期时间，为整数，单位为天，为负时删除cookie【可选】
         * @param {String} domain  指定cookie所属的域【可选】
         * @param {String} path  指定cookie 的路径【可选】
         * @param {Boolean} secure  是否安全传输 当协议为https时才可用【可选】
         * @param {Boolean} encode  是否对值进行encodeURIComponent【可选】
         */
        function __fn_SET_OR_DEL(options) {
            var ck = [];
            ck.push(options.name + '=');
            if (options.value) {
                ck.push(!!options.encode ? options.value : encodeURIComponent(options.value));
                //是否encodeURIComponent
            }
            if (options.expires) {
                var d = new Date();
                d.setHours(0);
                d.setMinutes(0);
                d.setSeconds(0);
                d.setTime(d.getTime() + options.expires * 86400000);
                //24 * 60 * 60 * 1000
                ck.push(';expires=' + d.toGMTString());
            }
            if (options.domain) {
                ck.push(';domain=' + options.domain);
            }
            ck.push(';path=' + (options.path || '/'));
            if (options.secure) {
                ck.push(';secure');
            }
            document.cookie = ck.join('');
        }

        return {
            /**
             * [获取cookie]
             * @example SEC.cookie.get('name')
             * @param {String} name cookie名称【必选】
             * @param {Boolean} encode 是否encodeURIComponent 默认false【可选】
             * @return 指定cookie的值
             */
            get: function(name, encode) {
                var m = document.cookie.match(new RegExp("(^| )" + name + "=([^;])*", "gi")), v = !m ? '' : m[0].split(name + '=')[1];
                return (!!encode ? v : decodeURIComponent(v));
            },

            /**
             * [设置cookie]
             * @description 用法参考私有方法(__fn_SET_OR_DEL)
             */
            set: __fn_SET_OR_DEL,

            /**
             * [删除cookie]
             * @description 用法参考私有方法(__fn_SET_OR_DEL)
             */
            del: __fn_SET_OR_DEL
        };
    })(),

    // 检测是否手机号
    isMobile: function(mobile) {
        return (/^1([3456789]\d{9})$/).test(mobile);
    },

    //执行统一打点统计
    doPointStatistics(ele){

    },
};

let ui = {
    // 倒计时
    countDown: function(ele, fnComplete, seconds) {
        var _This = this;
        seconds = seconds || 60;

        _move();
        clearInterval(ele.timer);
        ele.timer = setInterval(_move, 1000);

        function _move(){
            seconds--;
            if(seconds === 0){
                clearInterval(ele.timer);
                ele.innerHTML = '重新获取';
                fnComplete && fnComplete();
            }else{
                ele.innerHTML = '重新获取(' + seconds + 's)';
            }
        }
    },

    //切换按钮是否禁用状态
    toggleBtnDisabled: function (ele, isDisable, cls_disabled) {
        cls_disabled = cls_disabled || 'disabled';
        if(isDisable){
            ele.isClicked = true; // 设置不可点击
            ele.classList.add(cls_disabled);
        }else{
            ele.isClicked = false; // 设置不可点击
            ele.classList.remove(cls_disabled);
        }
    }
};


let api = (function() {
    let result = {};

    for(let attr in CONF_API){
        let item = CONF_API[attr];

        result[attr] = function(data){
            let type = item.method;
            let url = PREFIX_USER_CENTER + item.api;

            data = data || {};

            if(type === REQUEST_METHOD.GET){
                return Vue.http.get(url, {params: data});
            }else{
                return Vue.http.post(url, data);
            }
        };
    }

    return result;
})();


export default {
    name: "",
    data: () => ({
        mobile: '',                    // 手机号
        smscode: '',                   // 手机验证码
        imgcode: '',                   // 图片验证码
        cck: '',                       // 图片验证码对应的cck
        imgcode_src: '',               // 图片验证码对应的图片地址
        isShowModalIntegrate: false,   //是否显示新用户注册弹层
        isShowImgcodeFormInput: false, // 是否显示图形验证码行


        isShowAlert: false,
        alert_title: '',
        alert_content: '',
        alert_ok: function(){},
        alert_btnTrueText: '确定',
        alert_btnTrueHref: 'javascript: void(0);'
    }),
    created() {
        //显示弹层
        this.showModalIntegrate();
    },
    methods: {
        // 检测用户是否已登录
        checkUserLoggedIn: function(fnCb) {
            api.checkUserLogin({
                clientId: 3,
                upk: tools.cookie.get('Sid'),
                retExpandInfo: 1,
                retUserInfo: 1
            }).then(
                res => {
                    let data = res.body || {};

                    //0-成功(会话有效) 1300-会话失效
                    if(data.retCode === 1300){ //未登录或登录失效
                        tools.cookie.del({
                            name: 'SUN',
                            value: 0,
                            expires: -1,
                            domain: COOKIE_HOST_DOMAIN
                        });
                        tools.cookie.del({
                            name: 'Uid',
                            value: 0,
                            expires: -1,
                            domain: COOKIE_HOST_DOMAIN
                        });
                        tools.cookie.del({
                            name: 'Sid',
                            value: 0,
                            expires: -1,
                            domain: COOKIE_HOST_DOMAIN
                        });

                        fnCb && fnCb();
                    }
                },
                error => {
                    this.alert_open({
                        content: '亲，你的网络不给力吆'
                    });
                }
            );
        },

        // 显示弹层
        showModalIntegrate: function() {
            if(!localStorage.getItem('CLOSE_CONF_modalIntegrate')){ //检测有没有用户关闭标识
                // 检测用户是否已登录
                this.checkUserLoggedIn(() => {
                    this.isShowModalIntegrate = true;
                });
            }
        },

        // 关闭弹框
        handle_closeModalIntegrate: function(){
            this.isShowModalIntegrate = false;
            try{
                localStorage.setItem('CLOSE_CONF_modalIntegrate', true); //设置关闭标识
            }catch(e){}
        },

        // 获取手机验证码
        handle_getSmscode: function(target) {
            let oThis = target;
            let oMobile = this.$refs.mobile;
            let oImgcode = this.$refs.imgcode;
            let oBtnVerifyCode = this.$refs.btnVerifyCode;
            let mobile = this.mobile.trim();
            let imgcode = this.imgcode.trim();

            if(oThis.isClicked){ // 不可重复点击
                return;
            }

            if(mobile === ''){
                this.alert_open({
                    content: '请输入手机号',
                    ok: () => {
                        oMobile.focus();
                    }
                });
                return;
            }

            if(!tools.isMobile(mobile)){
                this.alert_open({
                    content: '请输入正确的手机号',
                    ok: () => {
                        oMobile.focus();
                    }
                });
                return;
            }

            //如果存在图形验证码则对其值进行相应验证
            if(this.isShowImgcodeFormInput){
                if(imgcode === ''){
                    this.alert_open({
                        content: '请输入图形验证码',
                        ok: () => {
                            oImgcode.focus();
                        }
                    });
                    return;
                }

                if(imgcode.length < 4){
                    this.alert_open({
                        content: '请输入正确的图形验证码',
                        ok: () => {
                            oImgcode.focus();
                        }
                    });
                    return;
                }
            }

            //有值时，则添加当前数据
            var data = {
                clientId  : 3, // 客户端 3-m端
                bid       : 9, // 业务id
                mobile    : mobile, // 手机号
                blackbox  : global_blackBox // 添加同盾设备指纹2019-05-31
            };

            if(imgcode){
                data.verifyCode = imgcode; // 图片验证码值
                data.cck = this.cck // 图片验证码cck
            }
            //console.log(data);

            // 设置不可点击
            ui.toggleBtnDisabled(oThis, true);

            api.getSmscode(data).then(
                res => {
                    let data = res.body || {};
                    /**
                     * 0    -成功
                     * 10001-失败
                     * 10002-您的操作太频繁
                     * 10003-您的操作太频繁,请1小时后再试
                     * 10004-您的操作太频繁,请24小时后再试 10005 您所在的IP操作太频繁,请24小时后再试，或切换网络
                     * 10006-请求短信频繁，请输入图形验证码
                     * 10007-图形验证码已失效
                     * 10008-图形验证码输入错误
                     * 10009-请输入正确的手机号
                     */
                    switch(data.retCode){
                        case 0:
                            // 开启倒计时
                            ui.countDown(oThis, function() {
                                // 恢复可点击
                                ui.toggleBtnDisabled(oThis, false);
                            });
                            break;
                        case 10006: // 请求短信频繁，请输入图形验证码
                            this.alert_open({
                                content: data.retMsg,
                                ok: () => {
                                    this.isShowImgcodeFormInput = true;
                                    oBtnVerifyCode.click();
                                    // 恢复可点击
                                    ui.toggleBtnDisabled(oThis, false);
                                }
                            });
                            break;
                        case 10007:
                        case 10008:
                            this.alert_open({
                                content: data.retMsg,
                                ok: () => {
                                    oBtnVerifyCode.click();
                                    // 恢复可点击
                                    ui.toggleBtnDisabled(oThis, false);
                                }
                            });
                            break;
                        default:
                            this.alert_open({
                                content: data.retMsg,
                                ok: () => {
                                    // 恢复可点击
                                    ui.toggleBtnDisabled(oThis, false);
                                }
                            });
                    }
                },
                error => {
                    // 恢复可点击
                    ui.toggleBtnDisabled(oThis, false);
                    this.alert_open({
                        content: '亲，你的网络不给力吆'
                    });
                }
            );
        },

        // 获取图形验证码
        handle_getVerifyCode: function(target) {
            let oThis = target;
            let oImgcode = this.$refs.imgcode;

            //清空输入框，并获取焦点
            this.imgcode = '';
            oImgcode.focus();

            // 恢复可点击
            ui.toggleBtnDisabled(oThis, true);

            api.getCaptcha({
                bizType: 'quickLogin', //快速登录-quickLogin
                blackbox: global_blackBox // 添加同盾设备指纹2019-05-31
            }).then(
                res => {
                    let data = res.body || {};

                    if(data.retCode === 0){
                        let obj = data.object;
                        this.imgcode_src = 'data:image/jpeg;base64,' + obj.base64Img,
                        this.cck = obj.cck;
                    }else{
                        this.alert_open({
                            content: data.retMsg
                        });
                    }
                    // 恢复可点击
                    ui.toggleBtnDisabled(oThis, false);
                },
                error => {
                    // 恢复可点击
                    ui.toggleBtnDisabled(oThis, false);
                    this.alert_open({
                        content: '亲，你的网络不给力吆'
                    });
                }
            );
        },

        // 立即领取
        handle_getReward: function(target) {
            let oThis = target;
            let oMobile = this.$refs.mobile;
            let oImgcode = this.$refs.imgcode;
            let oSmscode = this.$refs.smscode;
            let oBtnVerifyCode = this.$refs.btnVerifyCode;
            let mobile = this.mobile.trim();
            let smscode = this.smscode.trim();

            //如果已经点击了，则直接退出
            if(oThis.isClicked){ return;}

            //验证手机号是否为空
            if(mobile === ''){
                this.alert_open({
                    content: '请输入手机号',
                    ok: () => {
                        oMobile.focus();
                    }
                });
                return;
            }

            //验证手机号是否正确
            if(!tools.isMobile(mobile)){
                this.alert_open({
                    content: '请输入正确的手机号',
                    ok: () => {
                        oMobile.focus();
                    }
                });
                return;
            }

            //验证手机验证码是为空
            if(smscode === ''){
                this.alert_open({
                    content: '请输入手机验证码',
                    ok: () => {
                        oSmscode.focus();
                    }
                });
                return;
            }

            //验证手机验证码是否正确
            if(smscode.length !== 4){
                this.alert_open({
                    content: '请输入正确的手机验证码',
                    ok: () => {
                        oSmscode.focus();
                    }
                });
                return;
            }

            //alert('ok');
            var data = {
                clientId   : 3, // 客户端 3-m端
                mobilePhone: mobile, // 手机号
                verifyCode : smscode // 短信验证码
            };

            //console.log(data);
            //执行统一打点统计
            tools.doPointStatistics && tools.doPointStatistics({
                id: '新用户注册送优惠券+积分--立即领取'
            });

            // 设置不可点击
            ui.toggleBtnDisabled(oThis, true);

            api.quickLogin(data).then(
                res => {
                    let data = res.body || {};

                    /**
                     * 0-成功
                     * 10001-缺失参数
                     * 10002-账户已冻结
                     * 10003-登录失败
                     * 10004-验证码已失效
                     * 10005-验证码错误
                     * 10006请输入正确的手机号
                     */
                    switch(data.retCode){
                        case 0:
                            /**
                             * return {
                             *     retCode: 0,
                             *     retMsg: '成功',
                             *     object: {
                             *         uid: '130819272046',  用户userid
                             *         upk: 'upkupkupk'   用户登录成功标识
                             *         isNewUser(是否新用户)- 有没有购买过商品
                             *         isSecooUser是否为寺库新用户 - 有没有注册过； 1是 0否
                             *     }
                             * }
                             */
                            let obj = data.object || {};

                            if(obj.isSecooUser){
                                this.alert_open({
                                    title: '领取成功！',
                                    content: '2500元优惠券礼包及5000积分已存入您的账户，下单时可抵现金使用。',
                                    btnTrueText: '去逛逛',
                                    ok: () => {
                                        // 设置登录cookies
                                        this.toLogin(mobile, obj);
                                        // 隐藏弹框
                                        this.handle_closeModalIntegrate();
                                    }
                                });
                            }else{
                                this.alert_open({
                                    title: '您已是注册用户！',
                                    content: '您已是老用户，把福利留给更多新朋友吧！去逛逛发现更多精彩！',
                                    btnTrueText: '去逛逛',
                                    ok: () => {
                                        // 设置登录cookies
                                        this.toLogin(mobile, obj);
                                        // 隐藏弹框
                                        this.handle_closeModalIntegrate();
                                    }
                                });
                            }

                            break;
                        case 10004: //短信验证码已失效
                            this.alert_open({
                                content: data.retMsg,
                                ok: () => {
                                    //如果存在图形验证码则对其值进行相应验证
                                    if(this.isShowImgcodeFormInput){
                                        oBtnVerifyCode.click();
                                    }
                                    this.smscode = ''; //清空短信验证码输入框
                                }
                            });
                            break;
                        case 10005: //短信验证码错误
                            this.alert_open({
                                content: data.retMsg,
                                ok: () => {
                                    this.smscode = '';
                                    oSmscode.focus(); //获取焦点
                                }
                            });
                            break;
                        default:
                            this.alert_open({
                                content: data.retMsg
                            });
                    }
                    // 恢复可点击
                    ui.toggleBtnDisabled(oThis, false);
                },
                error => {
                    // 恢复可点击
                    ui.toggleBtnDisabled(oThis, false);
                    this.alert_open({
                        content: '亲，你的网络不给力吆'
                    });
                }
            );
        },

        // 设置登录cookies
        toLogin(mobile, obj) {
            tools.cookie.set(
                {
                    name: 'SUN',
                    value: mobile,
                    expires: COOKIE_MAX_AGE,
                    domain: COOKIE_HOST_DOMAIN
                }
            ); // 种用户名
            tools.cookie.set(
                {
                    name: 'Uid',
                    value: obj.uid,
                    expires: COOKIE_MAX_AGE,
                    domain: COOKIE_HOST_DOMAIN
                }
            ); // 种用户userid
            tools.cookie.set(
                {
                    name: 'Sid',
                    value: obj.upk,
                    expires: COOKIE_MAX_AGE,
                    domain: COOKIE_HOST_DOMAIN
                }
            );
        },

        //输入框输入时
        handle_input(target, type) {
            let val = target.value.trim();
            let ele_type = target.type;

            //对tel类型的输入框做去除非数字处理
            if(ele_type === 'tel'){
                val = val.replace(/[^\d]/g, '');
            }
            this[type] = target.value = val;
        },

        // 打开
        alert_open(opts) {
            opts = opts || {};
            this.alert_title = opts.title || '';
            this.alert_content = opts.content || '';
            this.alert_btnTrueText = opts.btnTrueText || '确定';
            this.alert_ok = opts.ok || function(){};
            this.isShowAlert = true;
        },

        // 关闭
        alert_close(cb) {
            this.isShowAlert = false;
            this.alert_ok();
        },

        //alert弹框-确定按钮
        handle_fnOk(){
            this.alert_close();
        }
    }
}
</script>
<style lang="scss" scoped>
    .modal-wrap {
        position: fixed;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        z-index: 1000;
    }
    /* 新用户注册 弹层 */
    .modal-integrate {
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        z-index: 100;
        background: rgba(0, 0, 0, 0.6);

        ::-webkit-input-placeholder {
            color: #ccc;
        }

        &,
        .inner-integrate {
            position: fixed;
        }

        .inner-integrate {
            top: 50%;
            left: 50%;
            padding-top: toRem(332); /* 332px */
            width: toRem(610); /* 610px */
            background: url(//mpic.secooimg.com/images/2018/06/13/bg-integrate.png) no-repeat top center;
            background-size: 100% auto;

            -webkit-transform: translate(-50%, -50%);
            transform: translate(-50%, -50%);
        }

        .btn-close {
            position: absolute;
            top: toRem(20); /* 20px */
            right: toRem(20); /* 20px */
            width: toRem(50); /* 50px */
            height: toRem(50); /* 50px */
            background: url(//mpic.secooimg.com/images/2018/06/13/btn-close.png) no-repeat center/toRem(28) toRem(28); /* 28px */
        }

        .integrate-msg {
            margin-top: toRem(-70); /* -70px */
            font-size: toRem(28); /* 28px */
            line-height: toRem(40); /* 40px */
            color: #CDA77D;
            text-align: center;
        }

        @at-root .form-send {
            padding-top: toRem(30); /* 30px */
            background: #fff;

            .inner-send {
                margin: 0 auto;
                padding-bottom: toRem(30); /* 30px */
                width: toRem(539); /* 539px */
            }

            @at-root .form-input {
                display: -webkit-box;
                display: box;
                display: -webkit-flex;
                display: flex;
                -webkit-box-pack: justify;
                box-pack: justify;
                -webkit-justify-content: space-between;
                justify-content: space-between;
                margin-top: toRem(20); /* 20px */

                &:nth-of-type(1) {
                    margin-top: 0;
                }

                * {
                    -webkit-box-sizing: border-box;
                    box-sizing: border-box;
                    -webkit-user-select: text;
                }

                .input-control {
                    padding-left: toRem(20); /* 20px */
                    border: 1px solid rgba(28,23,23,0.30);
                    height: toRem(90); /* 90px */

                    -webkit-box-flex: 1;
                    box-flex: 1;
                    -webkit-flex: 1;
                    flex: 1;

                    input {
                        margin-top: toRem(15); /* 15px */
                        width: 100%;
                        height: toRem(60); /* 60px */
                        font-size: toRem(28); /* 28px */
                        line-height: toRem(60); /* 60px */
                        outline: 0;
                    }
                }

                .form-verifycode,
                .get-smscode {
                    display: block;
                    margin-left: toRem(20); /* 20px */
                    width: toRem(200); /* 200 */
                    height: toRem(90); /* 90px */
                    font-size: toRem(28); /* 28px */
                    line-height: toRem(90); /* 90px */
                    text-align: center;
                }

                .get-smscode {
                    border: 1px solid #1C1717;

                    &.disabled {
                        border-color: #DDD;
                        background: #DDD;
                        color: #Ffff;
                    }
                }

                .form-verifycode {
                    padding: toRem(8); /* 8px */
                    background: #eee;
                }

                .form-verifyimg {
                    display: block;
                    width: 100%;
                    height: 100%;
                }
            }

            .form-submit {
                display: block;
                margin-top: toRem(30); /* 30px */
                line-height: toRem(90); /* 90px */
                font-size: toRem(30); /* 30px */
                text-align: center;
                color: #FFF;
                background: -webkit-linear-gradient(-182deg, #3A3A3A 0%, #1C1717 100%);
                background: linear-gradient(-182deg, #3A3A3A 0%, #1C1717 100%);
            }
        }
    }

    /* alert 弹层样式 */
    .panel-box,
    .panel {
        position: fixed;
    }
    .panel-box {
        -display: none;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        z-index: 1000;
        background-color: rgba(0, 0, 0, 0.6);
    }
    .panel {
        top: 50%;
        right: toRem(100);
        left: toRem(100);
    }
    .panel-inner {
        overflow: hidden;
        @include border-radius(8px);
        @include transform(translate(0, -50%));
        background: #FFF;
    }
    .panel-title {
        font-size: toRem(30);
        text-align: center;
        color: #1A191E;
    }
    .panel-content {
        padding: toRem(58) toRem(50);
        border-bottom: 1px solid #ECECEC;
        font-size: toRem(28);
        line-height: toRem(40);
        text-align: center;
        color: #333;

        h2 {
            margin-top: toRem(-10);
            height: toRem(60);
            font-size: toRem(30);
            text-align: center;
        }
    }
    .panel-footer {
        @extend %flex-horizontal;
        @include box-pack(justify);
        height: toRem(102);
        text-align: center;
        font-size: toRem(30);
        line-height: toRem(102);
        color: #1A191E;

        a {
            display: block;
            @include flex(1);
        }
    }
    //确认弹层
    .panel-confirm {
        a {
            margin-left: -1px;
        }
        @at-root .panel-btnCancel {
            border-right: 1px solid #FFF;
        }
        @at-root .panel-btnTrue {
            border-left: 1px solid #ECECEC;
        }
    }
    .panel-titleConfirm {
        .panel-title {
            padding: toRem(54) 0 0;
        }
        .panel-content {
            padding: toRem(24) toRem(50) toRem(48);
            -text-align: left;
        }
    }
    .hide {
        opacity: 0;
    }
    .tl {
        text-align: left;
    }
    .tc {
        text-align: center;
    }

    .fade-enter-active, .fade-leave-active {
        transition: background-color .3s;
    }
    .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
        background-color: rgba(0, 0, 0, 0);
    }
    .bounce-enter-active {
      animation: bounce .15s cubic-bezier(0.25, 0.1, 0.76, 1.38);
    }
    .bounce-leave-active {
      animation: bounce .15s cubic-bezier(0.25, 0.1, 0.76, 1.38) reverse;
    }

    @keyframes -webkit-bounce {
        0% {
            opacity: 0;
            -webkit-transform: scale(0.7) translateZ(0);
            transform: scale(0.7) translateZ(0);
        }
        100%{
            opacity: 1;
            -webkit-transform: scale(1) translateZ(0);
            transform: scale(1) translateZ(0);
        }
    }
    @keyframes bounce {
        0% {
            opacity: 0;
            -webkit-transform: scale(0.7) translateZ(0);
            transform: scale(0.7) translateZ(0);
        }
        100%{
            opacity: 1;
            -webkit-transform: scale(1) translateZ(0);
            transform: scale(1) translateZ(0);
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/MNewUserRegister/index.vue